import Text from 'components/elements/text';
import useGetCruiseRoom from 'hooks/use-get-cruise-room';
import { SeparatorVertical } from 'legacy-modules/styles';
import * as React from 'react';
import { useFormContext } from 'react-hook-form';

import CruiseGuestDetailTable from './item-table';
import CruiseGuestDetailGroupedTable from './item-table-grouped';
import { CruisePurchaseFormType } from '../../form-type';

export default function GroupDetailTable({
  parentIndex = 0,
}: {
  parentIndex?: number;
}) {
  const name = `cruisePurchases.${parentIndex}` as const;
  const { getValues } = useFormContext<CruisePurchaseFormType>();

  const { isGroupedPrice, cruisePurchaseGuests, cruiseId } = getValues(name);

  const { isFetching, options } = useGetCruiseRoom({ cruiseId });

  if (!cruiseId || !cruisePurchaseGuests.length) {
    return <></>;
  }

  if (!cruisePurchaseGuests.length || isFetching) {
    return <></>;
  }

  if (isGroupedPrice) {
    return (
      <CruiseGuestDetailGroupedTable
        cruiseRoomList={options}
        parentIndex={parentIndex}
      />
    );
  }

  return (
    <>
      {cruisePurchaseGuests
        .filter((curr) => !!curr.guestId)
        .map((field, idx) => (
          <React.Fragment key={field.customId}>
            <Text variant="ParagraphSmall">{field.guestName || '-'}</Text>
            <SeparatorVertical $margin={16} />
            <CruiseGuestDetailTable
              guest={field}
              cruiseRoomList={options}
              parentIndex={parentIndex}
            />
            <SeparatorVertical $margin={24} />
          </React.Fragment>
        ))}
    </>
  );
}
